import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import {
  getApiCall,
  postApiCall,
  postFormApiCall,
} from "../../../../utils/api";
import Swal from "sweetalert2";
import stateList from "../../../../data/states.json";

const initialFormData = {
  schoolName: "",
  schoolType: "",
  schoolAddress: "",
  schoolPinCode: "",
  schoolState: "",
  schoolCity: "",
  schoolPhone: "",
  schoolEmail: "",
  coordinatorName: "",
  coordinatorDesignation: "",
  coordinatorPhone: "",
  coordinatorEmail: "",
  numberOfStudents: "",
};

const schoolTypes = ["Government", "Private"];
const designations = ["Principal", "Vice Principal", "Teacher", "Admin"];

const SchoolIndividual = ({ setIsOpen, fetchData }) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState(initialFormData);
  const [cityList, setCityList] = useState([]);
  const [otherCity, setOtherCity] = useState("");

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "schoolState") {
      const selectedState = stateList.states.find(
        (state) => state.state_code === value
      );
      setCityList(selectedState ? selectedState.cities : []);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default HTML form submission behavior
    console.log("Form submitted:", formData);
    const requestData = {
      school: {
        name: formData.schoolName,
        description: `${formData.schoolName}'s Description`,
        image:
          "https://firebasestorage.googleapis.com/v0/b/snipe-nrsm.appspot.com/o/569241.png?alt=media&token=d8c9d5b8-d1cd-4f47-82ae-c9384c6fe6db",
        class_numbers: [-2, -1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        section_count: 1,
        model: "DIGITAL",
        address:
          formData.schoolAddress +
          ", " +
          (formData.schoolCity === "Other"
            ? formData.otherCity
            : formData.schoolCity) +
          ", " +
          formData.schoolState,
        pincode: formData.schoolPinCode
          ? parseInt(formData.schoolPinCode)
          : undefined,
        state_code: formData.schoolState,
        phone: formData.schoolPhone,
        email: formData.schoolEmail,
        coordinator_designation: formData.coordinatorDesignation,
        city:
          formData.schoolCity === "Other"
            ? formData.otherCity
            : formData.schoolCity,
        schoolType: formData.schoolType,
        numberOfStudents: formData.numberOfStudents,
      },
      admin: {
        name: formData.coordinatorName,
        phone: formData.coordinatorPhone,
        email: formData.coordinatorEmail,
      },
    };
    // return;
    console.log("Request Data:", requestData);
    const res = await postApiCall("school/create-new-school-via-admin", {
      school: requestData.school,
      admin: requestData.admin,
    });

    console.log(res);

    if (res.success === false) {
      // if (setIsOpen) setIsOpen(false);

      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    fetchData();

    if (setIsOpen) setIsOpen(false);
  };

  const handleCancel = () => {
    setFormData(initialFormData);
    if (setIsOpen) setIsOpen(false);
  };

  return (
    <div>
      {loading == true ? (
        "Loading......."
      ) : (
        <Box p={4}>
          <Typography variant="h5" gutterBottom>
            School Registration
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              {/* School Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="School Name"
                  name="schoolName"
                  value={formData.schoolName}
                  onChange={handleChange}
                  placeholder="Enter School Name"
                />
              </Grid>

              {/* School Type */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>School Type</InputLabel>
                  <Select
                    name="schoolType"
                    value={formData.schoolType}
                    onChange={handleChange}
                  >
                    {schoolTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* School Address */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="School Address"
                  name="schoolAddress"
                  value={formData.schoolAddress}
                  onChange={handleChange}
                  placeholder="Enter School Address"
                />
              </Grid>

              {/* PIN Code */}
              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  fullWidth
                  label="PIN Code"
                  name="schoolPinCode"
                  value={formData.schoolPinCode}
                  onChange={handleChange}
                  placeholder="Enter PIN Code"
                />
              </Grid>

              {/* State */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>School State</InputLabel>
                  <Select
                    name="schoolState"
                    value={formData.schoolState}
                    onChange={handleChange}
                    displayEmpty
                  >
                    {stateList.states
                      ?.sort((a, b) => a.name.localeCompare(b.name))
                      ?.map((state) => (
                        <MenuItem
                          key={state.state_code}
                          value={state.state_code}
                        >
                          {state.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* City */}
              <Grid item xs={12} sm={6}>
                <Grid container spacing={2}>
                  <Grid item xs={formData.schoolCity === "Other" ? 6 : 12}>
                    <FormControl fullWidth>
                      <InputLabel>School City</InputLabel>
                      <Select
                        name="schoolCity"
                        value={formData.schoolCity}
                        onChange={handleChange}
                        displayEmpty
                      >
                        {cityList.map((city) => (
                          <MenuItem key={city} value={city}>
                            {city}
                          </MenuItem>
                        ))}
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {formData.schoolCity === "Other" && (
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Enter Other City"
                        name="otherCity"
                        value={otherCity}
                        onChange={(e) => setOtherCity(e.target.value)}
                        placeholder="Enter custom city name"
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {/* School Phone Number */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="School Phone Number"
                  name="schoolPhone"
                  value={formData.schoolPhone}
                  onChange={handleChange}
                  placeholder="Enter School Phone Number"
                />
              </Grid>

              {/* School Email */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="School Email"
                  name="schoolEmail"
                  value={formData.schoolEmail}
                  onChange={handleChange}
                  placeholder="Enter School Email"
                />
              </Grid>

              {/* Coordinator Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="School Coordinator's Name"
                  name="coordinatorName"
                  value={formData.coordinatorName}
                  onChange={handleChange}
                  placeholder="Enter Coordinator's Name"
                />
              </Grid>

              {/* Coordinator Designation */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Coordinator's Designation</InputLabel>
                  <Select
                    name="coordinatorDesignation"
                    value={formData.coordinatorDesignation}
                    onChange={handleChange}
                  >
                    {designations.map((des) => (
                      <MenuItem key={des} value={des}>
                        {des}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Coordinator Phone */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  name="coordinatorPhone"
                  value={formData.coordinatorPhone}
                  onChange={handleChange}
                  placeholder="Enter Phone Number"
                  //   InputProps={{
                  //     endAdornment: (
                  //       <Button variant="text" size="small">
                  //         Verify
                  //       </Button>
                  //     ),
                  //   }}
                />
              </Grid>

              {/* Coordinator Email */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="School Coordinator's Email"
                  name="coordinatorEmail"
                  value={formData.coordinatorEmail}
                  onChange={handleChange}
                  placeholder="Enter Email Address"
                  //   InputProps={{
                  //     endAdornment: (
                  //       <Button variant="text" size="small">
                  //         Verify
                  //       </Button>
                  //     ),
                  //   }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  fullWidth
                  label="Number of Students"
                  name="numberOfStudents"
                  value={formData.numberOfStudents}
                  onChange={handleChange}
                  placeholder="Enter Number of Students"
                />
              </Grid>

              {/* Submit / Cancel */}
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
              >
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      )}
    </div>
  );
};

export default SchoolIndividual;
